// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElementComponentOf_wrapper__q4Qwe"};